import styled from "@emotion/styled";
import { Typography } from "@avenue-8/sidekick-ui";

export const PanelContainer = styled.div`
  padding: 2rem 4rem;

  ${(p) => p.theme.media.mobileDown} {
    padding: 1rem 1.5rem;
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;

  ${(p) => p.theme.media.tabletDown} {
    flex-direction: column;
  }
`;

export const PanelTitle = styled(Typography)`
  color: ${(p) => p.theme.text.colors.brand};
`;

export const PanelSubtitle = styled(Typography)`
  color: ${(p) => p.theme.text.colors.secondary};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fill,
    minmax(max(280px, (100% - 2rem) / 3), 1fr)
  );
  gap: 1rem;
  margin-bottom: 2.5rem;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.5rem;
  padding: 3rem 1.5rem;
  border: 1px solid ${(p) => p.theme.colors.border2};
  border-radius: 1rem;
  margin-bottom: 1.5rem;
`;

export const EmptyStateIconWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  margin-bottom: 0.5rem;
  border-radius: 50%;
  background-color: ${(p) => p.theme.colors.background5};
  color: ${(p) => p.theme.text.colors.brand};
`;

export const EmptyStateDescription = styled(Typography)`
  color: ${(p) => p.theme.text.colors.secondary};
  max-width: 34rem;
`;
